const importantQuotes = {
    svg: '<svg xmlns:xlink="http://www.w3.org/1999/xlink" style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path id="path-1" d="m9.2 5.8-.001 2.45H16v1.5H9.199L9.2 12.2 6 9zM13 1v2H1V1zm-11.5.5v13h11v-13zM0 0h14v16H0z"/></svg>',
};

export { importantQuotes as default };
